import {useEffect} from "react";
import { useNavigate } from "react-router-dom";

const DashboardReport = () => {
    const navigate = useNavigate()
    useEffect(()=>{
        navigate('/home')
    })
  return (
    <div></div>
  );
};

export default DashboardReport;
